<template>
  <v-card class="align-stretch" height="100%" :loading="currentLeadLoading">
    <v-card-title>Static Data</v-card-title>
    <v-card-text v-if="!currentLeadLoading">
      <v-row>
        <v-col>
          <p class="mb-1 text-caption">Added Date</p>
          <p><b>{{currentLead.added | notEmpty}}</b></p>

          <p class="mb-1 text-caption">Sold Date</p>
          <p><b>{{currentLead.sold | notEmpty}}</b></p>

          <p class="mb-1 text-caption">Live Date</p>
          <p><b>{{currentLead.confirmed | notEmpty}}</b></p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    computed: {
      ...mapState('leads', ['currentLead','currentLeadLoading']),
    },
    filters: {
      notEmpty: function(val) {
        return (val === null || val === "" || val === undefined)?'-':val;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
